.bd-button {
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  -webkit-font-smoothing: antialiased;
  display: inline;
  align-items: center;
  box-sizing: border-box;
  text-decoration: none;
  padding: 10px 26px 8px 28px;
  text-align: center;
  cursor: pointer;
  color: #fff;
  background-color: #eb0000;
  border: 2px solid #eb0000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-radius: 8px;
  height: fit-content;
}

.bd-button:hover {
  background-color: #B10304;
  border-color: #B10304;
}

.bd-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}